<template>
  <div class="parents">
    <!-- <div class="steps">
      <div class="steps_top">
        <img class="steps_bar_size" :src="imagePath+'/info_entry.png'" />
      </div>
    </div> -->

    <div class="prompt">
      <div class="prompt_title">
        <span class="prompt_title_sub">请上传车主身份证</span>
      </div>
    </div>

    <!-- <cube-loading :size="30" :class=" isLoading ? 'Isloading' : 'loading'"></cube-loading> -->

    <div class="id_card_component">
      <div class="id_card_outter">
        <div class="id_card_inner_left">
          <photograph-minor
            v-model="menImage"
            @upload="uploadMen"
            :iconbackground="imagePath+'/idCard_frontside.png'"
          ></photograph-minor>
          <span class="id_card_title">身份证人像面</span>
        </div>
        <div class="id_card_inner_right">
          <photograph-chief
            v-model="emblemImage"
            @upload="uploadEmblem"
            :iconbackground="imagePath+'/idCard_backside.png'"
          ></photograph-chief>
          <span class="id_card_title">身份证国徽面</span>
        </div>
      </div>
    </div>

    <div class="prompt">
      <div class="prompt_title">
        <span class="prompt_title_sub">请核对证件信息</span>
      </div>
    </div>

    <cube-form :model="menData" :schema="schema"></cube-form>

    <div class="but_ton">
      <button class="next_btn" v-preventReClick @click="check">实名认证</button>
    </div>
    <!-- 遮罩层 -->
    <cube-popup type="my-popup" ref="myPopup"></cube-popup>
    <div class="show_loading">
      <cube-loading :size="60" v-show="show"></cube-loading>
    </div>
  </div>
</template>

<script>
import { axios } from "../../util/request";
import { log } from "util";
import uuidv1 from "uuid/v1";
const TOKEN = "TOKEN";
const HOUSEHOLDER = "HOUSEHOLDER";
const OPEN_ID = "OPEN-ID";
const ACCESSTOKEN = "ACCESSTOKEN";
import Photograph from "../photograph";
import PhotographChief from "../photographChief";
import PhotographMinor from "../photographMinor";
import fileAxios from "axios";

export default {
  // inject:['reload'],

  data() {
    return {
      show: false,
      imagePath: process.env.BASES_IMG_PATH,
      menImage: "",
      emblemImage: "",
      isLoading: false,
      secXtimer:'',
      //身份证识别信息
      menData: {
        userId: sessionStorage.getItem("USER-ID"),
        tokenId: sessionStorage.getItem("TOKEN-ID"),
        realName: "",
        cardNum: "",
        address: "",
        gender: "",
        nation: "",
        birthday: "",
        imageStr: "",
        side: ""
      },

      indicator: {
        negative: true,
        remain: true
      },
      creditIssuer: {
        name: "",
        cardNum: "",
        userId: sessionStorage.getItem("USER-ID"),
        positiveImageStr: "",
        negativeImageStr: ""
      },
      //身份证文件更新
      idCardInfo: {
        idCardId: "", //身份证卡Id
        annexFrontId: "", //人像面文件服务器照片id
        annexBackId: "", //国徽面文件服务器存储照片id
        address: "" //身份证地址是允许客户修改
      },
      //身份证文件服务器数据域
      idCardFile: {
        action: "",
        faceImg: "",
        backImg: ""
      },
      //前往文件服务器上传身份证文件    需要token
      filesUpload: {
        clientId: process.env.CLIENTID,
        token: sessionStorage.getItem("CONCRETE-TOKEN-ID"),
        fileName: "X.jpg",
        contentType: "image/jpeg",
        encrypt: true,
        base64File: ""
      },
      filesUploadUrl: process.env.FILESERVER,
      schema: {
        fields: [
          // 身份证姓名
          {
            type: "input",
            modelKey: "realName",
            label: "姓名",
            props: {
              //   placeholder: '身份证姓名',
              disabled: true
            },
            rules: {
              // 检验规则
              required: true,
              type: "string",
              min: 2,
              max: 15
            },
            trigger: "blur"
          },
          // 身份证号
          {
            type: "input",
            modelKey: "cardNum",
            label: "身份证号",
            props: {
              //   placeholder: '身份证号码',
              type: "string",
              disabled: true
            },
            rules: {
              // 检验规则
              required: true,
              type: "string",
              min: 15,
              max: 18
            },
            trigger: "blur"
          },
          //地址
          {
            type: "input",
            modelKey: "address",
            label: "家庭住址",
            props: {
              //   placeholder: '身份证地址',
              type: "string",
              eye: {
                open: false
              }
            },
            rules: {
              // 检验规则
              required: true,
              type: "string",
              min: 5,
              max: 100
            },
            trigger: "blur"
          },
          // 下一步
          {
            // component :TruckingButton
          }
        ]
      }
    };
  },
  
  methods: {
    //身份证人像面上传
    uploadMen() {

      if (this.menImage) {
        this.openLoading();
        setTimeout(() => {
          this.menData.imageStr = this.menImage.replace("data:image/jpeg;base64,","");
          this.creditIssuer.positiveImageStr = this.menImage.replace("data:image/jpeg;base64,","");
          //存储文件缓存
          this.idCardFile.faceImg = this.menImage;
          this.menData.side = 1;
          axios.post("/Ocr/Idcard", this.menData).then(data => {
            this.menData.realName = data.realName;
            this.menData.cardNum = data.cardNum;
            this.menData.address = data.address;
            this.menData.gender = data.gender;
            this.menData.nation = data.nation;
            this.menData.birthday = data.birthday;
            // 走开户的流程
            this.creditIssuer.cardNum = data.cardNum;
            this.creditIssuer.name = data.realName;
            this.closeLoading();
          }).catch(error=>{
            this.closeLoading();
          });
        }, 1000);
      }
    },
    uploadIdCard(img, side) {
      // 串行上传文件
    if (img) {
      this.filesUpload.base64File = img.replace("data:image/jpeg;base64,","");
      this.filesUpload.fileName = uuidv1() + ".jpg";
      let options = {
        url: this.filesUploadUrl,
        data: this.filesUpload,
        method: "post",
        headers: {
        "Content-Type": "application/json"
        }
      };
      fileAxios(options).then(res => {
          console.log(res);
          if (res.status == 200) {
            //国徽面身份证进行赋值
            switch (side) {
              case 1:
                this.idCardInfo.annexFrontId = res.data.fileId;
                //身份证国徽面上传
                if (this.idCardFile.backImg) {
                  this.uploadIdCard(this.idCardFile.backImg, 2);
                } else {
                  this.showMessage("平台照片服务器在获取人像面身份证时失败！");
                }
                break;
              case 2:
                this.idCardInfo.annexBackId = res.data.fileId;
                //身份证数据更新
                this.upDateIdCardInfo();
                break
              default:
                this.showMessage("文件服务器：身份证信息错误，请重新上传身份证");
                break;
            }
          }else{
            this.showMessage("文件服务器网络错误："+res.status+"，无法上传照片,请重新上传身份证");
          }
        }).catch(error=>{
          this.closeLoading();
        });
    } else {
      this.showMessage(img);
      this.showMessage("数据组装问题form：failed，身份证信息上传失败，再点一次试试^_^。");
    }
  },
    //更新身份证信息
    upDateIdCardInfo() {
      //验证身份证更新信息是否为空
      if(this.idCardInfo.idCardId.length!= 0&&this.idCardInfo.annexFrontId.length!=0&&this.idCardInfo.annexBackId.length!=0){
        axios.post("/IdCard/UpdateIdCard", this.idCardInfo).then(data => {
            if (data.status == 1) {
                axios.post("/Certify/ChannelCreditIssuer", this.creditIssuer).then(data => {
                    if (data.state == 1) {
                      //1代表开户正常完成的标识位
                      // 新流程车牌发行验证
                      sessionStorage.setItem(OPEN_ID, data.openId);
                      sessionStorage.setItem(ACCESSTOKEN, data.accessToken);
                      sessionStorage.setItem("ACCOUNT-ID", data.accountId);
                      this.$router.push({name:'mainProcess'});
                      // axios.post('/Vehicle/CheckIsHasVehicle',{userId: sessionStorage.getItem("USER-ID")}).then(data => {
                      //   if(1 === data.state){
                      //     this.$router.push({name:'vehicleDetection'});
                      //   }else{
                      //     this.$router.push({name:'vehicleCertify'});
                      //   }
                      // }).catch(error=>{
                      //   this.closeLoading();
                      // }); 
                    } else {
                      this.showMessage(data.info);
                    }
                }).catch(error=>{
                  this.closeLoading();
                });       
          } else if(this.idCardInfo.idCardId.length === 0){
            this.showMessage("身份证国徽面上传失败，请先重新上传身份证反面！");
          }else if(this.idCardInfo.annexFrontId.length===0||this.idCardInfo.annexBackId.length===0){
            this.showMessage("身份证人像面和国徽面均上传失败，请重新点击实名验证，如果多次不成功则需要重新拍两张身份证照片上传！");
          }else{
            this.showMessage("身份证上传失败，请重新点击实名验证，如果多次不成功则需要重新拍两张身份证照片上传！");
          }
        }).catch(error=>{
          this.$refs.closeLoading();
        });
    }
  },
    // 国徽文件上传
    uploadEmblem() {

      if (this.emblemImage) {
      this.openLoading();
        setTimeout(() => {
          this.menData.imageStr = this.emblemImage.replace("data:image/jpeg;base64,","");
          this.creditIssuer.negativeImageStr = this.emblemImage.replace("data:image/jpeg;base64,","");
          this.idCardFile.backImg = this.emblemImage;
          this.menData.side = 2;
          axios.post("/Ocr/Idcard", this.menData).then(data => {
            console.log(data);
            if (1 == data.state) {
              this.idCardInfo.idCardId = data.idCardId;
            } else {
              this.showMessage("身份证国徽面识别失败，未返回相关数据，请重新上传身份证反面。");
            }
            this.closeLoading();
          }).catch(error=>{
            this.closeLoading();
          });
        }, 1000);
      }
    },
    check() {
      this.openLoading();
      //检查身份证数据信息是否齐全
      if (
        this.menData.address.length === 0 &&
        this.menData.realName.length === 0 &&
        this.menData.cardNum.length === 0
      ) {
        this.showMessage("姓名、身份证号、住址不能为空");
      } else {
        this.next();
      }

    },
    next() {
      //上传身份证文件
      if (this.idCardFile.faceImg) {
        this.uploadIdCard(this.idCardFile.faceImg, 1);
      } else {
        this.showMessage(
          "平台服务器在获取人像面身份证时失败！" + this.idCardFile.faceImg
        );
      }
    },
    //遮罩层和loading的开关
    openLoading(){
      if(this.secXtimer){
        clearTimeout(this.secXtimer);
      }
      if(this.$refs.myPopup){
        this.$refs.myPopup.show();
      }
      this.show = true;
      this.secXtimer = setTimeout(() => {
        if(this.$refs.myPopup){
            this.$refs.myPopup.hide();
            this.show = false;
        }
      }, 7000);
    },
    closeLoading(){
      if(this.$refs.myPopup){
        this.$refs.myPopup.hide();
      }
      this.show = false;
    },
    showMessage(content) {
      this.closeLoading();
      this.$createDialog({
        type: "alert",
        title: "提示信息",
        content: content,
        icon: "cubeic-alert"
      }).show();
    },
    getUserInfo() {
      if(!sessionStorage.getItem('USER-ID') && !sessionStorage.getItem('TOKEN-ID')) {
        this.$router.push({name: 'home'});
      }
    }
  },
  mounted() {
    // 判断是否存在用户信息
    this.getUserInfo();
    // if(sessionStorage.getItem('USER-ID')) {
    //   axios.post("/User/Userinfo", { userId: sessionStorage.getItem('USER-ID') }).then(data => {
    //     console.log('用户的有效性',data);
    //     if(data.state != 1) {
    //       this.$router.push({path: '/'});
    //     }
    //   }).catch(err => {

    //   })
    // } else {
    //   this.$router.push({path: '/'});
    // }
  },
  components: {
    PhotographChief,
    PhotographMinor
  },
};
</script>


<style lang="stylus" scoped>
.parents {
  width: calc(100%);
  height: calc(100%);
  margin: 0px;
  padding: 0px;
  background-color: #ffffff;
  position: relative;
  padding-top: 2px;
}

.steps {
  width: calc(100%);
  height: 6rem;
  margin: 0rem auto;
}

.steps_top {
  width: calc(100%);
  height: 4rem;
  padding: 1rem 0 1rem 0;
}

.steps_bar_size {
  width: calc(100%);
  height: calc(100%);
  background: #FEFFFF;
}

.prompt {
  width: calc(100%);
  height: 3rem;
  margin: 0rem auto;
  background-color: #f18934;
}

.prompt_title {
  width: calc(100%);
  height: 1rem;
}

.prompt_title_sub {
  width: calc(100%);
  height: 1rem;
  color: #ffffff;
  font-weight: 500;
  line-height: 1rem;
  display: block;
  margin: 0rem 0 1rem 0;
  padding: 1rem 0 1rem 0;
  text-align: left;
  text-indent: 1rem;
  font-size: 15px;
}

.id_card_component {
  width: calc(100%);
  height: calc(100%);
  margin: 0rem auto;
  padding-top: 1.094rem;
}

.id_card_outter {
  width: 20rem;
  height: 9rem;
  margin: 0rem auto;
  padding-top: 2rem;
}

.id_card_inner_left {
  width: 10rem;
  height: 6rem;
  float: left;
}

.id_card_inner_right {
  width: 10rem;
  height: 6rem;
  float: right;
}

.id_card_title {
  height: 1rem;
  color: #A9A9A9;
  font-size: 12px;
  text-align: center;
  line-height: 1rem;
  margin-top: 1rem;
}

.but_ton {
  width: calc(100%);
  background: #fff;
  margin: 0rem auto;
  padding: 0px 0px 4px 0px;
}

.next_btn {
  width: 233px;
  text-align: center;
  background-color: #fff;
  color: #f18934;
  font-size: 15px;
  font-weight: 400;
  height: 40px;
  margin-top: 25px;
  border-radius: 20px;
  border: 1px solid #f18934;
}

.Isloading {
  position: fixed;
  top: 40%;
  left: 50%;
}

.loading {
  position: fixed;
  top: 40%;
  left: 50%;
  display: none;
}

.show_loading {
  position: absolute;
  top: 21rem;
  left: 10rem;
}
</style>


